import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { VariantType } from 'app/models/variantTypes.models';
import { VariantTypesService } from 'app/services/variant-types.service';

@Component({
  selector: 'app-create-edit-tipo-variante',
  templateUrl: './create-edit-tipo-variante.component.html',
  styleUrls: ['./create-edit-tipo-variante.component.css']
})
export class CreateEditTipoVarianteComponent implements OnInit {

  tvariant: VariantType;
  tipos: VariantType[] = [];
  form: UntypedFormGroup;
  nuevoValor: string = '';
  valores: string[] = [];
  indiceEdicion: number = -1;
  valorEditado: string = '';
  idTvariante: number;


  
  constructor(
    private fb: UntypedFormBuilder,
    private variantTypeService: VariantTypesService,
    private router: Router,
    private routerActive: ActivatedRoute
  ) {
    this.form = this.fb.group({
      code: ['', Validators.required],
      name: ['', Validators.required],
      value: [''],
      properties: new UntypedFormControl(''),
      seeColor: new UntypedFormControl(0),
      seeSize: new UntypedFormControl(0),
      seePresentation: new UntypedFormControl(0)
    });
    this.idTvariante = this.routerActive.snapshot.params.id;
    if (this.idTvariante) {
      this.getVariantId();
    }
  }

  ngOnInit() {
    const valoresGuardados = this.form.get('value').value;
    if (valoresGuardados) {
        try {
            const valoresJSON = JSON.parse(valoresGuardados);
            this.valores = valoresJSON.map(item => item.valor);
        } catch (e) {
            // Si el formato no es JSON, intentamos el formato anterior
            this.valores = valoresGuardados.split(',').map(v => v.trim());
        }
    }
    const sidebar = <HTMLElement>document.querySelector(".navbar-brand");
    if (sidebar !== undefined) {
      sidebar.innerHTML = "Configuraciones - Nuevo Tipo de Variante";
    }
  }

  getVariantId() {
    this.variantTypeService.getVariantId(this.idTvariante).subscribe(
      (data: any) => {
        this.tvariant = data;
        if (this.tvariant) {
          this.form.patchValue(this.tvariant);
          this.valores = JSON.parse(this.tvariant.value).map((item: any) => item.valor);
        }      
      },
      (error) => {
        console.log(error);
      }
    );
  }

  saveVariant() {
    if (this.form.valid) {
        this.form.get('seeColor').setValue(this.form.get('seeColor').value ? true : false);
        this.form.get('seeSize').setValue(this.form.get('seeSize').value ? true : false);
        this.form.get('seePresentation').setValue(this.form.get('seePresentation').value ? true : false);
        if (!this.idTvariante) {
            this.variantTypeService.saveVariantType(this.form.value).subscribe(
              (data: any) => {
                  console.log('Variante guardada:', data);
                  this.router.navigate(['/configurar/tipovariantes']);
              },
              (error) => {
                  console.error('Error al guardar la variante:', error);
              }
          );
        } else {
            this.variantTypeService.updateVariantType(this.idTvariante, this.form.value).subscribe(
              (data: any) => {
                  console.log('Variante actualizada:', data);
                  this.router.navigate(['/configurar/tipovariantes']);
              },
              (error) => {
                  console.error('Error al actualizar la variante:', error);
              }
          );  
        }       
    }
  }

  agregarValor() {
    if (this.nuevoValor?.trim()) {
      this.valores.push(this.nuevoValor.trim());
      this.actualizarFormulario();
      this.nuevoValor = '';
    }
  }

  editarValor(indice: number, valor: string) {
    this.indiceEdicion = indice;
    this.valorEditado = valor;
  }

  guardarEdicion(indice: number) {
    if (this.valorEditado?.trim()) {
      this.valores[indice] = this.valorEditado.trim();
      this.actualizarFormulario();
    }
    this.indiceEdicion = -1;
    this.valorEditado = '';
  }

  eliminarValor(indice: number) {
    this.valores.splice(indice, 1);
    this.actualizarFormulario();
  }

  private actualizarFormulario() {
    // Convertimos el array de valores al formato requerido
    const valoresFormateados = this.valores.map(valor => ({
        valor: valor
    }));
    this.form.get('value').setValue(JSON.stringify(valoresFormateados));
  }

  

}
